import { ActivityLogInput, CompletionStatus } from '../../graphql/generated/graphql.ts';
import { FC } from 'react';
import { Autocomplete, Card, CardContent, Stack, TextField, Typography } from '@mui/material';
import { useGetActivityQuery } from '../../graphql/generated/operations/activity.ts';
import { ActivityView } from './activity-view.tsx';

export interface ActivityStatusFormProps {
  input: ActivityLogInput;
  onChange?: (e: ActivityLogInput) => void;
}

const options = [
  { id: CompletionStatus.NotCompleted, label: 'Not Completed' },
  { id: CompletionStatus.PartiallyCompleted, label: 'Partially Completed' },
  { id: CompletionStatus.Completed, label: 'Completed' }
];

export const ActivityStatusForm: FC<ActivityStatusFormProps> = ({ input, onChange }) => {
  const { data } = useGetActivityQuery({
    skip: !input.activityId,
    variables: { id: input.activityId }
  });

  return (
    <Stack spacing={2}>
      <ActivityView activity={data?.activity} />
      <Card>
        <CardContent>
          <Stack spacing={1}>
            <Typography>
              Did you complete the above activity on {input.day} {input.period}?
            </Typography>
            <Autocomplete
              options={options}
              getOptionLabel={(o) => o.label}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              value={options.find((o) => o.id === input.completed) ?? undefined}
              onChange={(_e, v) => {
                if (v) {
                  onChange?.({ ...input, completed: v.id });
                }
              }}
              renderInput={(params) => <TextField {...params} label="Completion Status" />}
              disableClearable
            />
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
};
